import TachoCodes from "assets/files/TachoCodes.json"

export function GetTachoCodesData() {
    return TachoCodes;
}